const faqs = [
  {
    question: '吃瓜网51是什么？怎么使用？',
    answer: '吃瓜网51是一个专注于娱乐资讯聚合的官方平台，为您提供最新最全的明星八卦、影视动态、综艺热点等内容。您可以直接通过吃瓜网51官网版网页版或正式版访问，在浏览器中输入官方首页入口地址即可畅享全部内容，无需注册登录即可浏览所有资讯。',
  },
  {
    question: '吃瓜网51的内容多久更新一次？',
    answer: '吃瓜网51实行7×24小时全天候更新机制，编辑团队实时追踪娱乐圈最新动态。无论是突发热点还是深度盘点，我们都会在第一时间进行内容更新与推送，确保您不会错过任何重要的吃瓜信息。',
  },
  {
    question: '吃瓜网51访问安全吗？如何找到官方入口？',
    answer: '吃瓜网51始终将用户访问安全放在首位。请认准吃瓜网51官方首页入口地址，我们的网页版与正式版均采用安全加密传输，保障您的浏览隐私与信息安全。建议收藏官方地址，避免通过不明渠道访问造成信息泄露。',
  },
  {
    question: '我可以在手机上使用吃瓜网51吗？',
    answer: '完全可以！吃瓜网51全面适配移动端浏览，无论是手机还是平板都能获得流畅的吃瓜体验。您可以直接在手机浏览器中打开吃瓜网51网页版，界面会自动适配您的屏幕尺寸，操作便捷、加载迅速，随时随地畅快吃瓜。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              关于吃瓜网51，您可能想了解的信息都在这里
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq) => (
              <div
                key={faq.question}
                className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-2">
                  {faq.question}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}